/**
 * 触发URL scheme调用
 * @param scheme URL scheme字符串
 */
function invokeScheme(scheme) {
  try {
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] invokeScheme called, scheme:', scheme);
    // 创建隐藏的iframe来触发scheme
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = scheme;
    document.body.appendChild(iframe);
    // 延迟移除iframe，确保scheme被触发
    setTimeout(() => {
      document.body.removeChild(iframe);
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] iframe removed after scheme invocation');
    }, 100);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[GTGJ Debug] Failed to invoke scheme:', scheme, error);
  }
}

/**
 * 初始化gtgj对象，通过URL scheme方式调用原生方法
 */
export function initGtgjBridge() {
  // 位置获取的Promise存储，用于回调
  // let locationResolve: ((value) => void) | null = null;
  // let locationReject: ((reason?: Error) => void) | null = null;

  let locationResolves = [];
  let locationRejects = [];

  const locationResolve = (value) => {
    locationResolves.forEach((resolve) => resolve(value));
    locationResolves = [];
    locationRejects = [];
  };
  const locationReject = (reason) => {
    locationRejects.forEach((reject) => reject(reason));
    locationResolves = [];
    locationRejects = [];
  };

  // 定义全局回调函数，供原生调用
  window.getLocationFinished = (locationInfo) => {
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] getLocationFinished called, locationInfo:', locationInfo);
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] locationInfo type:', typeof locationInfo);
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] locationInfo keys:', typeof locationInfo === 'object' ? Object.keys(locationInfo) : 'not an object');

    // 处理可能是字符串的情况
    let parsedInfo;
    if (typeof locationInfo === 'string') {
      try {
        parsedInfo = JSON.parse(locationInfo);
        // eslint-disable-next-line no-console
        console.log('[GTGJ Debug] Parsed JSON string, parsedInfo:', parsedInfo);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[GTGJ Debug] Failed to parse locationInfo as JSON:', e);
        if (locationRejects.length > 0) {
          locationReject(new Error('位置信息格式错误'));
        }
        return;
      }
    } else {
      parsedInfo = locationInfo;
    }

    // 将 status 转换为数字进行比较（原生可能返回字符串）
    const status = Number(parsedInfo.status);
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] parsed status:', status, 'original status:', parsedInfo.status);
    if (status === 1) {
      // 成功
      if (locationResolves.length > 0) {
        // 将 lat 和 lon 转换为数字
        const lat = Number(parsedInfo.lat);
        const lon = Number(parsedInfo.lon);
        // eslint-disable-next-line no-console
        console.log('[GTGJ Debug] parsed lat:', lat, 'lon:', lon);
        const geoInfo = {
          longitude: lon,
          latitude: lat,
        };
        // eslint-disable-next-line no-console
        console.log('[GTGJ Debug] Location resolved successfully:', geoInfo);
        locationResolve(geoInfo);
      } else {
        // eslint-disable-next-line no-console
        console.warn('[GTGJ Debug] getLocationFinished called but no pending resolve');
      }
    } else if (locationRejects.length > 0) {
      // eslint-disable-next-line no-console
      console.error('[GTGJ Debug] Location failed, status:', status, 'original:', parsedInfo.status);
      locationReject(new Error('获取位置信息失败'));
    } else {
      // eslint-disable-next-line no-console
      console.warn('[GTGJ Debug] getLocationFinished called but no pending reject');
    }
  };

  // 实现gtgj对象
  return {
    /**
     * 打开新webview
     * gtgj://start?type=gtweb&url=(需要打开的url encode)
     */
    openNewWebView(url) {
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] openNewWebView called, url:', url);
      const encodedUrl = encodeURIComponent(url);
      const scheme = `gtgj://start?type=gtweb&url=${encodedUrl}`;
      invokeScheme(scheme);
    },

    /**
     * 返回上一页
     * gtgj://start?type=webpopback
     */
    goBack() {
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] goBack called');
      const scheme = 'gtgj://start?type=webpopback';
      invokeScheme(scheme);
    },

    /**
     * 获取当前位置
     * gttcbus://start?type=gtbusLocation
     * 通过全局回调函数getLocationFinished返回结果
     */
    getLocation() {
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] getLocation called');
      return new Promise((resolve, reject) => {
        let timeout;
        const resolveFn = (value) => {
          if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
          }
          // eslint-disable-next-line no-console
          console.log('[GTGJ Debug] getLocation resolved:', value);
          resolve(value);
        };
        locationResolves.push(resolveFn);
        const rejectFn = (reason) => {
          if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
          }
          // eslint-disable-next-line no-console
          console.error('[GTGJ Debug] getLocation rejected:', reason);
          reject(reason || new Error('获取位置信息失败'));
        };
        locationRejects.push(rejectFn);

        // 设置超时，避免永久等待
        timeout = setTimeout(() => {
          // eslint-disable-next-line no-console
          console.error('[GTGJ Debug] getLocation timeout after 10s');
          locationResolves = locationResolves.filter((r) => r !== resolveFn);
          locationRejects = locationRejects.filter((j) => j !== rejectFn);
          reject(new Error('获取位置信息超时'));
        }, 10000); // 10秒超时

        // 触发获取位置的scheme
        const scheme = 'gttcbus://start?type=gtbusLocation';
        invokeScheme(scheme);
      });
    },

    /**
     * 拨打电话
     * gtgj://start?type=makePhoneCall&number=(需要拨打的号码)
     */
    callThePhone(phoneNumber) {
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] callThePhone called, phoneNumber:', phoneNumber);
      const scheme = `gtgj://start?type=makePhoneCall&number=${phoneNumber}`;
      invokeScheme(scheme);
    },

    /**
     * 关闭当前webview
     * gtgj://start?type=webpopback
     */
    closeWebView() {
      // eslint-disable-next-line no-console
      console.log('[GTGJ Debug] closeWebView called');
      const scheme = 'gtgj://start?type=webpopback';
      invokeScheme(scheme);
    },
  };
}

let gtgj;

export function getGtgj() {
  if (!gtgj) {
    // eslint-disable-next-line no-console
    console.log('[GTGJ Debug] gtgj not initialized, calling initGtgjBridge');
    gtgj = initGtgjBridge();
  }
  return gtgj;
}
